import {WicketApiUserField} from '../wicket-api-user-field';
import {WicketApiResponse} from '../wicket-api-response';
import {WicketUserAgreement} from '../wicket-user-agreement';

export interface WicketUserDataResponse extends WicketApiResponse<WicketApiUserField[]> {
  user_agreements: WicketUserAgreement[];
}
